
function assetPreviewDialog () {
  return {
    restrict: 'E',
    templateUrl: '/core/dialogs/asset-preview-dialog/asset-preview-dialog.html?$$REVISION$$'
  }
}
export { assetPreviewDialog }
